import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumb = ({ items }) => (
  <nav aria-label="Fil d'Ariane" data-testid="breadcrumb" className="flex flex-wrap items-center gap-1.5 text-xs text-steel">
    {items.map((item, i) => {
      const isLast = i === items.length - 1;
      return (
        <span key={item.label} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3 w-3 text-line" aria-hidden="true" />}
          {isLast || !item.to ? (
            <span className="font-medium text-midnight" aria-current="page">{item.label}</span>
          ) : (
            <Link to={item.to} className="transition-colors hover:text-midnight" data-testid={`breadcrumb-${item.label.toLowerCase()}`}>
              {item.label}
            </Link>
          )}
        </span>
      );
    })}
  </nav>
);

export default Breadcrumb;
